import { useSelector } from 'react-redux';

import { getAllAvailableExtensions, getAvailableFilesConfiguration, getMediaTypes, getSupportedTypes } from 'modules/app/selectors';

/** @typedef {{ mediaTypes?: string[], fileTypes?: string[], extensions?: string[], path?: string | string[], validators?: string[] }} AllowedMedias  */

const useMediaRules = ({ path, ...allowed } = {}) => {
  const allMediaTypes = useSelector(state => getMediaTypes(state, path));
  const mediaTypes = allowed.mediaTypes ?? allMediaTypes;

  const fileTypes = useSelector(state => getSupportedTypes(state, path, mediaTypes));
  const extensions = useSelector(state => getAllAvailableExtensions(state, path, mediaTypes));
  const config = useSelector(state => getAvailableFilesConfiguration(state, path));

  return {
    config,
    mediaTypes,
    fileTypes: allowed.fileTypes ?? fileTypes,
    extensions: allowed.extensions ?? extensions,
  };
};

export default useMediaRules;
